// What an outsourcing worker is owed.
//
// A job's payable value follows the pieces actually finished, so nothing here
// keys on `status`: a partly-finished job owes real money for the pieces done.
//
// `total_cost` is NOT the payable figure. It holds the value of the whole
// assignment, which the order-costing report in Reports.js attributes across
// delivered pieces. That is a costing number, not a payables one — the two
// answer different questions and must not be unified.
//
// Mirrors `job_earned_value` in backend/server.py. Keep the two in step.

export const jobEarned = (job) => {
  const done = Number(job?.completed_quantity) || 0;
  const qty = Number(job?.quantity) || 0;
  if (done <= 0) return 0;
  // A fully finished job uses the STORED total_cost rather than recomputing it.
  // Four legacy May-2026 rows carry hand-entered totals that disagree with
  // quantity x cost_per_piece — one by 485 EGP — so recomputing would restate
  // historical balances.
  if (qty > 0 && done >= qty) return Number(job.total_cost) || 0;
  return done * (Number(job.cost_per_piece) || 0);
};

export const workerEarned = (jobs = [], workerId) =>
  jobs.reduce((sum, j) => (j.worker_id === workerId ? sum + jobEarned(j) : sum), 0);

// Pieces still outstanding on a job.
export const jobRemaining = (job) =>
  Math.max((Number(job?.quantity) || 0) - (Number(job?.completed_quantity) || 0), 0);
